import { render } from "./ErrorPanel.vue?vue&type=template&id=38a5fc6f&scoped=true"
import script from "./ErrorPanel.vue?vue&type=script&lang=js"
export * from "./ErrorPanel.vue?vue&type=script&lang=js"

import "./ErrorPanel.vue?vue&type=style&index=0&id=38a5fc6f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38a5fc6f"

export default script